import { SrIcon } from "@/components/ui/SrIcon";

/**
 * Banner som vises øverst i tilbud-editoren når aktiv bruker verken er
 * forfatter (offers.created_by) eller admin/superadmin. Komplementerer
 * §7-RLS: dataen er allerede beskyttet, men dette gjør read-only-tilstanden
 * tydelig for brukeren. VIB-offer-author-gating.
 */
export function OfferReadOnlyBanner() {
  return (
    <div
      role="status"
      className="mb-3 flex items-center gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900 dark:border-amber-700/50 dark:bg-amber-950/40 dark:text-amber-200"
    >
      <SrIcon name="lock" className="w-4 h-4 shrink-0" aria-hidden />
      <span>
        Du kan ikke redigere dette tilbudet — kun eier, medredigerere og
        admin har redigeringstilgang.
      </span>
    </div>
  );
}
